import { combineReducers } from 'redux'

import registrationReducer from './registration'

const applicationReducers = combineReducers({
  registration: registrationReducer,
})

export default applicationReducers



// WEBPACK FOOTER //
// ./src/reducers/application.js